import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  RefundOrderRequest,
  SellerOrderPaymentView,
} from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateOrderPayment } from "@/lib/query/core/invalidation";

type RefundOrderInput = {
  storeSlug: string;
  orderId: string;
} & RefundOrderRequest;

type RefundOrderResponse = {
  transaction: SellerOrderPaymentView;
};

export function useRefundOrderMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: RefundOrderInput) => {
      const { storeSlug, orderId, ...body } = input;
      void storeSlug;
      return apiJsonClient<RefundOrderResponse>(
        endpoints.seller.orderRefund(orderId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      );
    },
    onSuccess: async (_data, variables) => {
      await invalidateOrderPayment(
        queryClient,
        variables.storeSlug,
        variables.orderId,
      );
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
